import React from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import RadioInput from "./RadioInput";
import WizardFooter from "./WizardFooter";
export const fields = [
  "referred_by_vocal_rehab",
  "referred_by_ticket_to_work",
  "referred_by_veterans_affairs",
];

const validate = (values, props) => {
  const errors = {};
  if (!values.referred_by_vocal_rehab) {
    errors.referred_by_vocal_rehab = props.allText.shared.required;
  }
  if (!values.referred_by_ticket_to_work) {
    errors.referred_by_ticket_to_work = props.allText.shared.required;
  }
  if (!values.referred_by_veterans_affairs) {
    errors.referred_by_veterans_affairs = props.allText.shared.required;
  }
  return errors;
};

export const WizardFormSection04 = props => {
  const {
    allText,
    fields: {
      referred_by_vocal_rehab,
      referred_by_ticket_to_work,
      referred_by_veterans_affairs,
    },
    handleSubmit,
    previousPage,
  } = props;
  const text = { ...allText.shared, ...allText.section04 };
  const progress = 3;
  return (
    <form onSubmit={handleSubmit} className="form-horizontal">
      <div className="wizard-page-content">
        <div className="page-title-container">
          <span className="page-title underline">{text.title}</span>
          <span className="wizard-text question-text">{text.subtitle}</span>
        </div>
        <div>
          <div className="primary-question">{text.primaryQuestion}</div>

          <div className="separator" />

          <div className="row single-question-bigger-margin">
            <div className="col-12 col-sm-4">
              <div className="wizard-text">{text.question01}</div>
              <RadioInput text={text} field={referred_by_vocal_rehab} />
            </div>
            <div className="col-12 col-sm-4">
              <div className="wizard-text">{text.question02}</div>
              <RadioInput text={text} field={referred_by_ticket_to_work} />
            </div>
            <div className="col-12 col-sm-4">
              <div className="wizard-text">{text.question03}</div>
              <RadioInput text={text} field={referred_by_veterans_affairs} />
            </div>
          </div>
        </div>
      </div>
      <WizardFooter
        text={text}
        previousPage={previousPage}
        progress={progress}
      />
    </form>
  );
};

WizardFormSection04.propTypes = {
  allText: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
};

export default reduxForm({
  form: "wizard",
  fields,
  destroyOnUnmount: false,
  validate,
})(WizardFormSection04);



// WEBPACK FOOTER //
// ./src/components/WizardFormSection04.js